/** The one error shape a failed request becomes (design.md §15): status, the API's code, its sentence, the request id to quote. */
export class ApiRequestError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    readonly requestId?: string,
  ) {
    super(message);
    this.name = "ApiRequestError";
  }
}
